var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex add-to-cart"},[_c('div',{staticClass:"quantity"},[_c('number-input',{attrs:{"value":_vm.payload.quantity},on:{"input":_vm.changeVal}})],1),_vm._v(" "),_c('button',{staticClass:"button",attrs:{"disabled":_vm.disableButton},on:{"click":function($event){return _vm.addToCart()}}},[_vm._v("\n      ADD TO CART\n  ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61edeca2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-cart/components/AddToCart.vue
// module id = /G1S
// module chunks = 1